module.exports = require('./lib/wix-data-schema-api')



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-schema-api/index.js
// module id = 258
// module chunks = 0